// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "thead.is-sticky[data-v-077e2abc],thead.is-sticky th[data-v-077e2abc]{position:sticky;top:0}.widget-link[data-v-077e2abc]:hover{cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
